export default __webpack_public_path__ + "static/media/Udemy.b32b0111.svg";